<template>
  <header class="main-header-mobile">
    <img :draggable="false" class="main-header-bg" :src="activityImages.mobile.header" alt="" />
  </header>
</template>

<script>
import activityImages from '../config/images';

export default {
  name: 'App',
  components: {},
  setup() {
    return {
      activityImages,
    };
  },
};
</script>

<style lang="less">
.main-header-mobile {
  display: none;
  overflow: hidden;
  position: relative;
  .main-header-bg {
    width: 100%;
  }
  .main-header-machine {
    position: absolute;
    top: 17%;
    left: -25%;
    width: 141%;
  }
  .main-header-title {
    position: absolute;
    top: 7px;
    z-index: 1;
    width: 99%;
    margin-left: -26px;
  }
  .main-header-cloud {
    position: absolute;
    top: 32%;
    width: 55%;
  }
}

@media screen and (max-width: 870px) {
  .main-header-mobile {
    display: block;
  }
}
</style>
